import { Button, Flex, Text } from '@backend/lib-design-system';
import { Features } from '@backend/lib-feature-mgr';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { styled } from 'styled-components';

import { CardItem, CardTitle } from '~/components/MissionsList/MissionListCard.style';
import { ApplyTypes } from '~/contexts/ApplyFormContext/enums';
import { useCheckFeatureEnabled, useTranslation } from '~/hooks';

// the apply form weighs ~160 KB (phone numbers of every country, reCAPTCHA): loaded when the visitor opens it
const ApplyFormModal = dynamic(() => import('~/components/ApplyFormModal').then(module => module.ApplyFormModal));

export const FreeApplicationColumn = styled(Flex.Column)`
  height: 100%;
  justify-content: center;
`;

export const MissionListFreeApplicationCard = () => {
  const t = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  const isCvRequired = useCheckFeatureEnabled(Features.JobBoardApplyCvRequired);

  return (
    <>
      <CardItem px="l" py="l">
        <FreeApplicationColumn space="l">
          <CardTitle variant="heading-3">{t('free_application_card.title')}</CardTitle>
          <Text variant="body-lighter">{t('free_application_card.message')}</Text>
          <Button
            size="xl"
            onClick={() => {
              setModalOpen(true);
            }}
          >
            {t('free_application_card.button')}
          </Button>
        </FreeApplicationColumn>
      </CardItem>
      {modalOpen && (
        <ApplyFormModal
          applyType={ApplyTypes.free}
          isCvRequired={isCvRequired}
          onClose={() => {
            setModalOpen(false);
          }}
        />
      )}
    </>
  );
};
